import { gql } from "apollo-boost";

export const DELETE_BOOKING = gql`
  mutation DeleteBooking($input: DeleteBookingInput!) {
    deleteBooking(input: $input)
  }
`;
